import { Injectable } from '@angular/core';
import { BookingGuestsService } from '../booking-guests.service';
import { LoginService } from '../login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  
  private readonly tokenStorageKey = 'auth_token';
  private token: string | null = null;

  constructor(
    private bookingGuestSvc : BookingGuestsService,
    private loginservice: LoginService
  ) {
    this.token = localStorage.getItem(this.tokenStorageKey);
  }

  public setToken(token: string): void {
    this.token = token;
    localStorage.setItem(this.tokenStorageKey, token);
  }

  public getToken(): string | null {
    return this.token;
  }

  public clearToken(): void {
    this.token = null;
    localStorage.removeItem(this.tokenStorageKey);
  }

  public hasToken(): boolean {
    return !!this.token;
  }

  async RefreshAuthToken() {

    const rawUserData = localStorage.getItem('userinfo');
    if (!rawUserData) return;
    
    const userdata = JSON.parse(rawUserData);

    if(userdata == '') return;
    
    const bookingUid = userdata?.rebuid; 
    const bookingCode = userdata?.rebcode; 
      
    const get_guests_response = await this.bookingGuestSvc.GetBookingGuestsAsync(
      Number(bookingUid),
      new AbortController()
    );

    if (get_guests_response.GetBookingGuests.Result.Status != "A"){
      console.error("Failed to retrieve booked guests.")
      return;
    }

    const guestLastName = get_guests_response.GetBookingGuests?.BookingGuestList[0]?.folSurName;

    if (guestLastName == null || guestLastName == undefined) {
      console.error("Failed to extract guests last name.")
      return;
    }

    const login_response = await this.loginservice.GetPortalLoginAsync(
      bookingCode, 
      guestLastName, 
      "",
      new AbortController()
    );

    if (login_response.GetPortalLogin.Result.Status != "A"){
      console.error("Failed to complete http request to refresh token.");
      return;
    }

    this.setToken(login_response.GetPortalLogin.Token);
      
  }
}
